<template>
    <div class="rounded-xl border border-blue-100 bg-blue-50 p-4 md:p-5">
        <div class="flex items-start justify-between gap-4">
            <div>
                <h3 class="text-sm font-semibold text-gray-900 md:text-base">
                    {{ $t("checkout.applyAll.title") }}
                </h3>
                <p class="mt-1 text-xs text-gray-600 md:text-sm">
                    {{ $t("checkout.applyAll.description") }}
                </p>
                <p v-if="modelValue" class="mt-2 text-xs font-medium text-blue-700">
                    {{ $t("checkout.applyAll.active", { count: totalRooms }) }}
                </p>
            </div>
            <button
                type="button"
                class="relative inline-flex h-6 w-10 items-center rounded-full transition"
                :class="modelValue ? 'bg-blue-600' : 'bg-gray-300'"
                @click="$emit('update:modelValue', !modelValue)"
                :aria-label="$t('checkout.applyAll.aria')"
            >
                <span
                    class="inline-flex h-5 w-5 transform items-center justify-center rounded-full bg-white shadow-sm transition"
                    :class="modelValue ? 'translate-x-4' : 'translate-x-0.5'"
                >
                    <AppIcon
                        :icon="modelValue ? 'mdi:check' : 'mdi:close'"
                        class="h-3 w-3"
                        :class="modelValue ? 'text-blue-600' : 'text-gray-400'"
                    />
                </span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "ApplyToAllToggle",
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        totalRooms: {
            type: Number,
            default: 0,
        },
    },
};
</script>
